import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowContentDetailsProps as Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  const addressConditions: string[] = [
    ...(props.preferenceConditions?.workplaces ?? []),
    ...(props.preferenceConditions?.averageAges ?? []),
    ...(props.preferenceConditions?.genderRatios ?? []),
    ...(props.preferenceConditions?.workEnvironments ?? []),
  ];

  const workingTimeConditions: string[] = [
    ...(props.preferenceConditions?.workStyles ?? []),
    ...(props.preferenceConditions?.holidaysVacations ?? []),
  ];

  const fetchIndex = (array: string[], target: string): boolean => {
    return array.length === array.indexOf(target) + 1;
  };

  const fetchSalarySection = (): boolean => {
    return props.salary !== '' ||
           props.salaryDetailPresent ||
           (props.preferenceConditions.compensationEvaluations && props.preferenceConditions.compensationEvaluations.length > 0);
  };

  const fetchWelfares = (): boolean => {
    return (props.welfares && props.welfares.length > 0) || props.welfareOtherPresent;
  };

  const fetchAddressSection = (): boolean => {
    const hasAddress = props.address && props.address.trim() !== '';
    const hasConditions = addressConditions.length > 0;
    return hasAddress || hasConditions;
  };

  const fetchWorkingTimeSection = (): boolean => {
    const hasWorkingTime = props.workingTime && props.workingTime.trim() !== '';
    const hasConditions = workingTimeConditions.length > 0;
    return hasWorkingTime || hasConditions;
  };

  return (
    <Presentation
      {...props}
      addressConditions={addressConditions}
      workingTimeConditions={workingTimeConditions}
      fetchIndex={fetchIndex}
      fetchSalarySection={fetchSalarySection}
      fetchWelfares={fetchWelfares}
      fetchAddressSection={fetchAddressSection}
      fetchWorkingTimeSection={fetchWorkingTimeSection}
    />
  );
};
